import { TextareaField } from '@app/components/various/Form';
import { getBillingAddress } from '@app/ducks';
import { isDefined } from '@app/utils/is';
import { Checkout, CheckoutForm } from '@typings';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { AddressSummary } from '../AddressSummary';

interface Props {
  checkoutFields: Checkout.Requirements;
  isLoading: boolean;
}

export const CheckoutAdditional = ({ checkoutFields, isLoading }: Props) => {
  const { additionalNotes } = checkoutFields;
  const invoiceAddress = useSelector(getBillingAddress);
  const { t } = useTranslation(['checkout', 'invoices']);
  const { register } = useFormContext<CheckoutForm>();

  const handleTextareaOnChange = React.useCallback(({ currentTarget }: React.SyntheticEvent<HTMLTextAreaElement>) => {
    // eslint-disable-next-line functional/immutable-data
    currentTarget.style.height = 'auto';
    // eslint-disable-next-line functional/immutable-data
    currentTarget.style.height = `${currentTarget.scrollHeight}px`;
  }, []);

  return (
    <div className="box">
      <h3 className="mb-5 heading-3">{t('checkout:additional_info')}</h3>
      <div className="space-y-5">
        <AddressSummary address={invoiceAddress} isLoading={isLoading} title={t('invoices:invoice_address')} />
        {isDefined(additionalNotes) && (
          <TextareaField
            {...register('additionalNotes', {
              onChange: handleTextareaOnChange,
            })}
            isLoading={isLoading}
            className="max-h-64 min-h-24 resize-y"
            placeholder={t('checkout:additional_info')}
            label={t('checkout:additional_notes')}
          />
        )}
      </div>
    </div>
  );
};
